import React from 'react';
import Ink from 'react-ink';
import Checkbox from './Checkbox';
import { VirtualTrashIcon } from '../../Icons';

class SelectTile extends React.Component {
  constructor(props) {
    super(props);

    this.handleCheck = this.handleCheck.bind(this);
  }

  handleCheck(value) {
    const { name, id, onChange } = this.props;
    if (typeof onChange === 'function') {
      onChange({
        name,
        id,
        value,
      });
    }
  }

  render() {
    const {
      id,
      name,
      label,
      labelHidden,
      autoHeight,
      type,
      selected,
      children,
      image,
      onDelete,
      onMouseEnter,
      onMouseLeave,
    } = this.props;

    const cardClasses = ['card', 'card--compact', 'select-tile'];
    if (selected) {
      cardClasses.push('select-tile--selected');
    }
    if (children) {
      if (image) {
        cardClasses.push('select-tile--with-image');
      } else {
        cardClasses.push('select-tile--with-text');
      }
    }
    if (autoHeight) {
      cardClasses.push('select-tile--autoheight');
    }

    const labelSpanClasses = ['select-tile--square__label'];
    if (labelHidden) {
      labelSpanClasses.push('sr-only');
    }

    return (
      <div className={cardClasses.join(' ')} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <Checkbox id={`check-${id}`} onCheck={this.handleCheck} checked={selected} type={type} name={name} />

        <div>
          <label htmlFor={`check-${id}`} className="select-tile__label">
            <span className={labelSpanClasses.join(' ')}>{label}</span>

            {children && <div>{children}</div>}

            <Ink />
          </label>
        </div>

        {!!onDelete && (
          <button onClick={onDelete} className="select-tile__delete">
            <VirtualTrashIcon />
            <span className="sr-only">Delete</span>
          </button>
        )}
      </div>
    );
  }
}

export default SelectTile;
